import { connect } from "react-redux";
import { Form, getIn } from "formik";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import Select from "react-select";

import { admin_cse, adminRoute } from "@/config/roles";
import { adminRequests } from "@/api/(requests)/admin";
import Button from "@/components/UI/Button";
import CardHeading from "@/components/UI/Headings/CardHeading";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { CustomForm } from "@/component-library/CustomForm";
import FormikInput from "@/components/UI/FormikInput";
import FormikMobileInput from "@/components/UI/formikMobileInput";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getQueryParams } from "@/utils/filters";
import InputError from "@/components/UI/InputError";
import { isAuthorized } from "@/utils/authToken";
import Label from "@/components/UI/Label";
import { ProviderDetails } from "@/components/Admin/Practice";
import { ProviderPracticeDetails } from "@/components/Admin/Provider/ProviderPracticeDetails";
import { providerRequests } from "@/api/(requests)/provider";
import { ProviderStatusDetails } from "@/components/Admin/Provider/ProviderStatusDetails";
import { sharedRequests } from "@/api/(requests)/shared";
import { ViewContent2 } from "@/components/layout/ViewContent";

import PatientsList from "../Providers/PatientsList/PatientsList";
import { VALIDATION_SCHEMA } from "../Providers/schema/providerProfileBasicValidation";

import { PROVIDER_DETAILS_SCHEMA } from "./schema/providerDetailsSchema";

class Provider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editProviderDetails: false,
      existingIntakePractices: [],
      hideBreadCrumb: getQueryParams("hideBreadCrumb", this.props.location.search),
      intakePracticeOptions: [],
      practiceId: this.props.match.params.practiceId,
      providerDetails: null,
      providerId: this.props.match.params.providerId,
      status: null,
    };
  }

  async componentDidMount() {
    await this.getProvider();
    this.getPatientList();
    this.getPractices();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.providerId !== this.props.match.params.providerId) {
      this.setState(
        {
          practiceId: this.props.match.params.practiceId,
          providerId: this.props.match.params.providerId,
        },
        () => this.componentDidMount(),
      );
    }
  }

  async getProvider({ context } = {}) {
    let searchParams = { practiceId: this.state.practiceId, providerId: this.state.providerId };
    let cleanResponse = await sharedRequests.fetch_practice_provider({ context, searchParams });

    this.setState({
      providerDetails: cleanResponse,
    });
  }

  getPractices() {
    if (
      this.state.providerDetails &&
      this.state.providerDetails.provider_type === "BEHAVIORAL_INTAKE"
    ) {
      (async () => {
        const response = await adminRequests.fetch_all_practices({
          context: { showLoader: false },
        });
        const intakePracticeOptions = response
          .filter((practice) => practice["practice_type"] === "Primary Care")
          .map((practice) => {
            return {
              label: practice["name"],
              value: practice["id"],
            };
          });
        const existingIntakePractices = intakePracticeOptions.filter(
          (option) =>
            Object.hasOwn(this.state.providerDetails, "intake_practice_ids") &&
            this.state.providerDetails["intake_practice_ids"].includes(option.value),
        );

        this.setState({
          existingIntakePractices,
          intakePracticeOptions,
        });
      })();
    }
  }

  getPatientList() {
    (async () => {
      let searchParams = { providerId: this.state.providerId };
      let cleanResponse = await adminRequests.fetch_patient_list({ searchParams });

      this.setState({
        patientList: cleanResponse.user,
      });
    })();
  }

  editButtonHandler = () => {
    this.setState((ps) => {
      return { editProviderDetails: !ps.editProviderDetails };
    });
  };

  submitHandler = (formData, actions) => {
    actions.setSubmitting(false);
    const data = { ...formData };

    data["intake_practice_ids"] = data["intake_practice_ids"]
      ? data["intake_practice_ids"].map((option) => (option.value ? option.value : option))
      : [];
    const searchParams = { providerId: this.state.providerId };

    providerRequests
      .update_profile({ data, searchParams })
      .then(() => {
        const existingIntakePractices = this.state.intakePracticeOptions.filter(
          (option) =>
            Object.hasOwn(data, "intake_practice_ids") &&
            data["intake_practice_ids"].includes(option.value),
        );

        this.setState({ existingIntakePractices, practiceDetails: data });
        this.editButtonHandler();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  submitHandlerV2 = (formData, actions) => {
    actions.setSubmitting(false);
    const data = { ...formData };

    data["intake_practice_ids"] = data["intake_practice_ids"]
      ? data["intake_practice_ids"].map((option) => (option.value ? option.value : option))
      : [];
    const searchParams = { providerId: this.state.providerId };

    providerRequests
      .update_profile({ data, searchParams })
      .then(() => {
        const existingIntakePractices = this.state.intakePracticeOptions.filter(
          (option) =>
            Object.hasOwn(data, "intake_practice_ids") &&
            data["intake_practice_ids"].includes(option.value),
        );

        this.setState({ existingIntakePractices, practiceDetails: data });
        this.editButtonHandler();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getProviderDetailsInitialValues = (providerDetails) => {
    return {
      cp_credentials: providerDetails?.cp_credentials,
      email: providerDetails?.email,
      intake_practice_ids: providerDetails?.intake_practice_ids,
      mobile: providerDetails?.mobile,
      name: providerDetails?.name,
      npi_number: providerDetails?.npi_number,
      practice: providerDetails?.practice,
      provider_type: providerDetails?.provider_type,
    };
  };

  renderForm = (formikProps) => {
    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="container px-0">
            <div className="row">
              {PROVIDER_DETAILS_SCHEMA.map((formEl) => {
                const error = getIn(formikProps.errors, formEl.name);
                const touched = getIn(formikProps.touched, formEl.name);

                return (
                  <div className="col-12 col-lg-6" key={formEl.name}>
                    {formEl.name === "provider_type" || formEl.name === "email" ? (
                      <FormikInput
                        disabled
                        errors={formikProps.errors}
                        formEl={formEl}
                        inputBorderDisabled="border-0 px-0"
                        touched={formikProps.touched}
                      />
                    ) : formEl.name === "mobile" ? (
                      <FormikMobileInput
                        errors={formikProps.errors}
                        formEl={formEl}
                        onChange={async (val) => {
                          await formikProps.setFieldValue("mobile", val.value);
                          formikProps.setFieldTouched("mobile");
                        }}
                        touched={formikProps.touched}
                        value={formikProps && formikProps.values.mobile}
                      />
                    ) : formEl.name === "intake_practice_ids" ? (
                      <>
                        {formikProps.values["provider_type"] === "BEHAVIORAL_INTAKE" && (
                          <div className="col-12 col-lg-6" key={formEl.name}>
                            <Label>{formEl.elementConfig.label}</Label>
                            <Select
                              className="basic-multi-select"
                              classNamePrefix="select"
                              components={{ ClearIndicator: null }}
                              defaultValue={this.state.existingIntakePractices}
                              isMulti
                              onChange={async (selectedOptions) =>
                                await formikProps.setFieldValue(formEl.name, selectedOptions)
                              }
                              options={this.state.intakePracticeOptions}
                            />
                            {error && touched ? (
                              <InputError classes="custom-error">{error}</InputError>
                            ) : null}
                          </div>
                        )}
                      </>
                    ) : (
                      <FormikInput
                        errors={formikProps.errors}
                        formEl={formEl}
                        touched={formikProps.touched}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="d-lg-flex d-block text-center justify-content-lg-end tw:justify-center">
          <Button
            className="Btn Btn--otl-pri Btn-sm mr-lg-3 mb-3 mb-lg-0"
            onClick={this.editButtonHandler}
            type="button"
          >
            Cancel
          </Button>

          <Button className="Btn Btn--pri Btn-sm" type="submit">
            Save
          </Button>
        </div>
      </Form>
    );
  };

  render() {
    if (!this.state.providerDetails || !this.state.patientList) {
      return <div />;
    }

    return (
      <ViewContent2
      // Adding a test locator here won't work
      >
        <header {...getAutomationDataAttr("ProviderPage")}>
          {!this.state.hideBreadCrumb && (
            <div className="mx-auto fs-14 my-3 py-2">
              <Link to={adminRoute + "/practice"}>
                <p className="d-inline ml-0">Practices</p>
              </Link>

              <Link to={adminRoute + "/practice/" + this.state.practiceId}>
                <p className="d-inline ml-0"> {">"} Practice Details</p>
              </Link>

              <span className="fs-14"> {">"} Provider Details</span>
            </div>
          )}

          <h3 className="fs-25 tw:font-bold">{this.state.providerDetails.name}</h3>
        </header>

        {!this.state.editProviderDetails && (
          <ProviderDetails
            existingIntakePractices={this.state.existingIntakePractices}
            onclick={this.editButtonHandler}
            providerDetails={this.state.providerDetails}
          />
        )}

        {this.state.editProviderDetails && (
          <CardSecondary className="mx-auto container Practice__Details">
            <div className="d-flex justify-content-between py-4">
              <CardHeading className="fs-18 m-0 px-3 px-lg-4" text="Provider Details" />
            </div>

            <CustomForm
              initialValues={this.getProviderDetailsInitialValues(this.state.providerDetails)}
              onSubmit={this.submitHandlerV2}
              render={this.renderForm}
              validationSchema={VALIDATION_SCHEMA}
            />
          </CardSecondary>
        )}

        {isAuthorized(admin_cse) && (
          <ProviderPracticeDetails providerDetails={this.state.providerDetails} />
        )}

        <ProviderStatusDetails
          providerDetails={this.state.providerDetails}
          // NOTE: this needs to be a new function here so that we have access
          // to the "this" keyword within getProvider
          refetchProvider={(args) => this.getProvider(args)}
        />

        <PatientsList
          {...this.props}
          group_auth_type="admin"
          patientList={this.state.patientList}
          practiceId={this.props.match.params.practiceId}
        />
      </ViewContent2>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    flags: state?.flags || {},
  };
};

export default connect(mapStateToProps, {})(Provider);
